import { gql } from "@apollo/client";

export const PLACE_SUGGESTIONS = gql`
	query PlaceSuggestions($params: LocationParams) {
		locations(params: $params) {
			placeSuggestions {
				placeId
				mainText
				secondaryText
				placeName
			}
		}
	}
`;

export const PLACE_DETAILS = gql`
	query PlaceDetails($params: LocationParams) {
		locations(params: $params) {
			placeDetails {
				placeId
				displayName
				formattedAddress
				gps {
					coordinates
				}
				types
				addressComponents {
					longText
					shortText
					types
				}
			}
		}
	}
`;
